/**
 * CMS Peptides & Co — Theme JavaScript
 */

'use strict';

/* =========================================================
   Age Gate
   ========================================================= */
(function initAgeGate() {
  const STORAGE_KEY = 'cms_age_verified';
  const gate = document.getElementById('age-gate');
  if (!gate) return;

  // Check if already verified this session
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      gate.classList.add('is-hidden');
      return;
    }
  } catch (e) {}

  // Show gate
  document.body.style.overflow = 'hidden';

  const acceptBtn = document.getElementById('age-gate-accept');
  const declineBtn = document.getElementById('age-gate-decline');
  const ageStep = document.getElementById('age-gate-step-age');
  const emailStep = document.getElementById('age-gate-step-email');
  const emailForm = document.getElementById('age-gate-email-form');
  const emailInput = document.getElementById('age-gate-email');
  const emailError = document.getElementById('age-gate-email-error');
  const humanCheck = document.getElementById('age-gate-human');
  const honeypot = document.getElementById('age-gate-company');
  const backBtn = document.getElementById('age-gate-back');

  if (acceptBtn) {
    acceptBtn.addEventListener('click', function () {
      ageStep.hidden = true;
      emailStep.hidden = false;
      gate.setAttribute('aria-labelledby', 'age-gate-email');
      window.setTimeout(function () { emailInput.focus(); }, 0);
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      emailStep.hidden = true;
      ageStep.hidden = false;
      gate.setAttribute('aria-labelledby', 'age-gate-title');
      acceptBtn.focus();
    });
  }

  if (declineBtn) {
    declineBtn.addEventListener('click', function () {
      window.location.replace('https://www.google.com/');
    });
  }

  if (emailForm) {
    emailForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!emailInput || !emailInput.checkValidity() || !humanCheck || !humanCheck.checked || (honeypot && honeypot.value.trim() !== '')) {
        emailError.hidden = false;
        if (!emailInput || !emailInput.checkValidity()) { emailInput.focus(); }
        else if (humanCheck) { humanCheck.focus(); }
        return;
      }
      emailError.hidden = true;
      try {
        sessionStorage.setItem(STORAGE_KEY, 'true');
        sessionStorage.setItem('cms_gate_email', emailInput.value.trim());
      } catch (e) {}
      gate.classList.add('is-hidden');
      gate.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  }
})();


/* =========================================================
   Mobile Navigation Toggle
   ========================================================= */
(function initMobileNav() {
  const toggle = document.querySelector('.site-header__menu-toggle');
  const nav = document.getElementById('mobile-nav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function () {
    const isOpen = nav.classList.toggle('is-open');
    toggle.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen);
    nav.setAttribute('aria-hidden', !isOpen);
  });

  // Close on outside click
  document.addEventListener('click', function (e) {
    if (!toggle.contains(e.target) && !nav.contains(e.target)) {
      nav.classList.remove('is-open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      nav.setAttribute('aria-hidden', 'true');
    }
  });
})();


/* =========================================================
   Desktop Dropdown Keyboard Navigation
   ========================================================= */
(function initDropdowns() {
  const items = document.querySelectorAll('.site-nav__item--has-dropdown');
  items.forEach(function (item) {
    const trigger = item.querySelector('.site-nav__link');
    if (!trigger) return;
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', !expanded);
      }
    });
  });
})();


/* =========================================================
   Product Carousel
   ========================================================= */
(function initCarousel() {
  const carousel = document.getElementById('product-carousel');
  if (!carousel) return;

  const prevBtn = document.querySelector('.carousel-btn--prev');
  const nextBtn = document.querySelector('.carousel-btn--next');
  if (!prevBtn || !nextBtn) return;

  function getScrollAmount() {
    const slide = carousel.querySelector('.featured-products__slide');
    if (!slide) return 240;
    return slide.offsetWidth + 16; // width + gap
  }

  nextBtn.addEventListener('click', function () {
    carousel.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  prevBtn.addEventListener('click', function () {
    carousel.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  // Update button states
  function updateButtons() {
    prevBtn.disabled = carousel.scrollLeft <= 0;
    nextBtn.disabled = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth - 1;
    prevBtn.style.opacity = prevBtn.disabled ? '0.35' : '1';
    nextBtn.style.opacity = nextBtn.disabled ? '0.35' : '1';
  }
  carousel.addEventListener('scroll', updateButtons, { passive: true });
  updateButtons();
})();


/* =========================================================
   Product Page — Image Thumbnails
   ========================================================= */
(function initProductGallery() {
  const mainImg = document.getElementById('product-main-image');
  if (!mainImg) return;

  const thumbs = document.querySelectorAll('.product-page__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const src = thumb.getAttribute('data-image-src');
      if (src) {
        mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }
    });
  });
})();


/* =========================================================
   Product Variant Selection
   ========================================================= */
(function initProductVariants() {
  const form = document.getElementById('product-form');
  const variantInput = document.getElementById('product-variant-id');
  const variantsJson = document.getElementById('product-variants-json');
  if (!form || !variantInput || !variantsJson) return;

  let variants = [];
  try { variants = JSON.parse(variantsJson.textContent || '[]'); } catch (e) { return; }
  const selects = Array.from(form.querySelectorAll('.product-form__select[data-option-index]'));
  if (!selects.length) return;

  function syncVariant() {
    const selected = selects.map(function (select) { return select.value; });
    const match = variants.find(function (variant) {
      return selected.every(function (value, index) {
        return variant.options && variant.options[index] === value;
      });
    });
    if (match) { variantInput.value = String(match.id); }
  }

  selects.forEach(function (select) { select.addEventListener('change', syncVariant); });
  syncVariant();
})();

/* =========================================================
   Quantity Input
   ========================================================= */
(function initQuantityInputs() {
  document.querySelectorAll('.quantity-input').forEach(function (wrap) {
    const input = wrap.querySelector('.quantity-input__field');
    const minusBtn = wrap.querySelector('.quantity-input__btn--minus');
    const plusBtn = wrap.querySelector('.quantity-input__btn--plus');
    if (!input || !minusBtn || !plusBtn) return;

    minusBtn.addEventListener('click', function () {
      const current = parseInt(input.value, 10) || 1;
      if (current > 1) input.value = current - 1;
    });
    plusBtn.addEventListener('click', function () {
      const current = parseInt(input.value, 10) || 1;
      input.value = current + 1;
    });
  });
})();


/* =========================================================
   Hero Canvas — Gold Particle Effect
   ========================================================= */
(function initHeroCanvas() {
  const canvas = document.getElementById('hero-canvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  let W, H, particles;
  const PARTICLE_COUNT = 80;

  function resize() {
    W = canvas.width = canvas.offsetWidth;
    H = canvas.height = canvas.offsetHeight;
  }

  function Particle() {
    this.reset();
  }
  Particle.prototype.reset = function () {
    this.x = Math.random() * W;
    this.y = Math.random() * H;
    this.size = Math.random() * 2.5 + 0.5;
    this.speedX = (Math.random() - 0.5) * 0.4;
    this.speedY = -Math.random() * 0.6 - 0.2;
    this.alpha = Math.random() * 0.6 + 0.1;
    this.decay = Math.random() * 0.003 + 0.001;
    // Gold color variants
    const hue = 40 + Math.random() * 20;
    const sat = 60 + Math.random() * 40;
    const lit = 45 + Math.random() * 30;
    this.color = 'hsl(' + hue + ',' + sat + '%,' + lit + '%)';
  };
  Particle.prototype.update = function () {
    this.x += this.speedX;
    this.y += this.speedY;
    this.alpha -= this.decay;
    if (this.alpha <= 0 || this.y < -10) this.reset();
  };
  Particle.prototype.draw = function () {
    ctx.save();
    ctx.globalAlpha = this.alpha;
    ctx.fillStyle = this.color;
    ctx.shadowBlur = 4;
    ctx.shadowColor = this.color;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  };

  function init() {
    resize();
    particles = [];
    for (var i = 0; i < PARTICLE_COUNT; i++) {
      var p = new Particle();
      p.y = Math.random() * H; // spread vertically on init
      particles.push(p);
    }
  }

  function animate() {
    ctx.clearRect(0, 0, W, H);
    particles.forEach(function (p) { p.update(); p.draw(); });
    requestAnimationFrame(animate);
  }

  window.addEventListener('resize', resize, { passive: true });

  init();
  animate();
})();


/* =========================================================
   Smooth scroll for anchor links
   ========================================================= */
document.querySelectorAll('a[href^="#"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
